<template>
  <div :class="className"  class="click-wrapper" @pointerdown="onPointerDown">
    <slot></slot>
 </div>
</template>
<script>

const clickRadius = 10;
export default {
  props: {
    className: {type: String, default: ""},
    onClick: {type: Function, default: () => {}},
  },
  methods: {
    onPointerDown(pointerDownEvent) {
      const onPointerUp = (pointerUpEvent) => {
        const deltaX = pointerUpEvent.clientX - pointerDownEvent.clientX;
        const deltaY = pointerUpEvent.clientY - pointerDownEvent.clientY;
        const dist = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        if (dist <= clickRadius) {
          this.onClick();
        }
        document.removeEventListener("pointerup", onPointerUp);
      }
      document.addEventListener("pointerup", onPointerUp);
    }
  },
}
</script>
